import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';
import { channelIdOf, channelNameOf, fromName, openChannelFromNotification } from './ModeratorPromotedNotification';

/**
 * "X saiu de #canal e agora você é o dono."
 *
 * Vai para o moderador mais antigo quando o dono sai (Service\OwnershipSuccession).
 * Ninguém perguntou a ele, então precisa ser avisado.
 */
export default class OwnershipInheritedNotification extends Notification {
  icon() {
    return 'fas fa-crown';
  }
  href() {
    const channelId = channelIdOf(this);
    return channelId ? app.route('chat.channel', {
      id: channelId
    }) : app.route('chat.index');
  }
  content() {
    return app.translator.trans('ramon-chat.forum.notifications.ownership_inherited', {
      username: fromName(this),
      channel: channelNameOf(this)
    });
  }
  excerpt() {
    return null;
  }
  onclick(e) {
    openChannelFromNotification(this, e);
  }
}
flarum.reg.add('ramon-chat', 'forum/components/OwnershipInheritedNotification', OwnershipInheritedNotification);